// extracted by mini-css-extract-plugin
module.exports = {"modal_page_root":"_24B61DtbqzSg8m6LhDUJdk","modal_page_content":"_2Ek0bpPLM-XY-qyDH4rTFB"};